import config from '../config'
import axios from 'axios'

const baseurl = `${config.host}`
const request = create()

function create (url = baseurl) {
  return axios.create({
    baseURL: url,
    timeout: 100000,
    withCredentials: true, // 允许跨域 cookie
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
    transformResponse: [function (data) {
      let json = {}
      try {
        json = JSON.parse(data)
      } catch (e) {
        json = {}
      }
      return json
    }]
  })
}

export default request



// WEBPACK FOOTER //
// ./src/store/api.js